import React from 'react';
import { Image } from 'react-bootstrap';
import './Loader.css';

const Loader = ({ loading }) => {
  return (
    <>
      <div className={loading === true ? 'dimmer dimmer-active' : 'dimmer'}>
        <div className="dimmer-back"></div>
        <Image src="/assets/images/loading.gif" className="dimmer-loading" />
      </div>
    </>
  );
};

export default React.memo(Loader);
